// Module
var code = "<h3>Profile</h3> <div class=\"card\"> <h5 id=\"user-name-header\">Test Name here</h5> <hr/> <div id=\"profile-form\" class=\"grid grid-cols-3 gap-x-6 gap-y-3 pt-8\"></div> </div> <div class=\"flex items-center justify-end\"> <button id=\"updateProfileBtn\" onclick=\"thsPage.updateProfile()\" class=\"mt-8 mr-4\">Update Profile</button> </div> ";
// Exports
export default code;